module.exports = __webpack_public_path__ + "static/BildTextLogo-a531445149801dff7919c603af99b52d.png";